// Animated number: counts toward the new value over ~400ms (spec 13.4: number changes animate).
import { useEffect, useRef, useState } from "preact/hooks";

const reduced = typeof matchMedia !== "undefined" && matchMedia("(prefers-reduced-motion: reduce)").matches;

export function Tween({ value, format, class: cls = "num" }: { value: number; format: (n: number) => string; class?: string }) {
  const [shown, setShown] = useState(value);
  const from = useRef(value);
  const dir = useRef<"up" | "down" | "">("");
  useEffect(() => {
    if (reduced || shown === value) {
      setShown(value);
      return;
    }
    from.current = shown;
    dir.current = value > shown ? "up" : "down";
    const start = performance.now();
    let raf = 0;
    const step = (now: number) => {
      const t = Math.min(1, (now - start) / 400);
      const e = 1 - (1 - t) ** 3;
      setShown(from.current + (value - from.current) * e);
      if (t < 1) raf = requestAnimationFrame(step);
      else dir.current = "";
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [value]);
  return <span class={`${cls} ${dir.current ? `tween-${dir.current}` : ""}`}>{format(shown)}</span>;
}
